export default __webpack_public_path__ + "static/media/mailDefault.34272644.svg";